import useHttpClient from 'hooks/useHttpsClient';
import Toast from 'components/toast/Toast';

const useProfileService = () => {
    const { sendRequest } = useHttpClient();

    const showErrorMessage = (message) => {
        Toast.error(message)
      };
    
    const showSuccessMessage = (message) => {
        Toast.success(message)
      };

      const downloadFile = async () => {
        try {
            const response = await sendRequest('/global/download-file', 'get');
            
            if (response.data?.fileUrl) {
                const fileResponse = await fetch(process.env.REACT_APP_API_endpoint + response.data.fileUrl);
                const blob = await fileResponse.blob();
                
                const url = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = url;
                link.download = 'calendar.pdf';
                
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(url);
            }
        } catch (err) {
            showErrorMessage("Problem downloading file: " + err.message);
            throw err;
        }
    };

    const postSupportRequest = async (supportData) => {
        try {
            const response = await sendRequest('/support/ups', 'post', supportData, {
                'Content-Type': 'multipart/form-data'
            });
            
            if (response.status === 200) {
                showSuccessMessage("The Request reached we will review it and back with a response")
                return response.data;
            } else {
                throw new Error(`Server responded with status: ${response.status}`);
            }
        } catch (err) {
            showSuccessMessage("Problem sending support request: "+ err.message);
            throw err; 
        }
    };
    const postQuoteRequest = async (quoteData) => {
        try {
            const response = await sendRequest('/quote/cq', 'post', quoteData);
            
            if (response.status === 200) {
                showSuccessMessage("The Quote reached we will review it and back with an email")
                return response.data;
            } else {
                throw new Error(`Server responded with status: ${response.status}`);
            }
        } catch (err) {
            showSuccessMessage("Problem sending Quote request: " + err.message);
            throw err; 
        }
    };

    return {
        postSupportRequest,
        postQuoteRequest,
        downloadFile,
    };
};

export default useProfileService;